export const SIGNATURE_LEAD = '\n\n'

export function hasSignature(signature: string | null | undefined): boolean {
  return typeof signature === 'string' && signature.trim().length > 0
}

// Idempotent: a resend or a manually pasted signature must not double it. A blank
// body still returns the signature, because an attachment-only email is a valid
// send and has to carry the sign-off too.
export function appendSignatureForSend(
  body: string,
  signature: string | null | undefined
): string {
  if (!hasSignature(signature)) {
    return body
  }
  const trimmedSignature = (signature as string).trim()
  const trimmedBody = body.replace(/\s+$/, '')
  if (!trimmedBody) {
    return trimmedSignature
  }
  if (trimmedBody.endsWith(trimmedSignature)) {
    return trimmedBody
  }
  return `${trimmedBody}${SIGNATURE_LEAD}${trimmedSignature}`
}
